module.exports = __webpack_public_path__ + "static/precedence-update-category-plan-3993191dadda7560bcfefc6bdece65b9.png";